import { render, staticRenderFns } from "./DescargarCatalogo.vue?vue&type=template&id=6f6a8978&scoped=true"
import script from "./DescargarCatalogo.vue?vue&type=script&lang=js"
export * from "./DescargarCatalogo.vue?vue&type=script&lang=js"
import style0 from "./DescargarCatalogo.vue?vue&type=style&index=0&id=6f6a8978&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6a8978",
  null
  
)

export default component.exports